// src/pages/admin/marketing/MarketingActivities.jsx

import React from 'react';
import FieldActivitiesPanel from './components/FieldActivitiesPanel';

const MarketingActivities = () => {
  return <FieldActivitiesPanel />;
};

export default MarketingActivities;
